<template>
  <div class="pr-item" :class="variant">
    <div class="recuento-container">
      <div>
        <b>{{ caption }}</b>
      </div>
      <span class="recuento">{{ recuento }}</span>
      / <span class="promedio-value">{{ promedio }} días</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "Promedio",
  props: {
    caption: {
      type: String,
      required: true,
    },
    variant: {
      type: String,
      default: "info",
    },
    promedio: {
      type: [Number, String],
      required: true,
    },
    recuento: {
      type: [Number, String],
      required: true,
    },
  },
};
</script>
